import React from "react";

function Footer() {
  return (
    <footer>
      <h6> Ruhi Enterprise &copy; developed by gowave</h6>
    </footer>
  );
}

export default Footer;
